import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { v7 as uuidv7 } from 'uuid';

import { TopBar } from '@app/shared/ui/molecules/Common';
import { Form, StoriesSection } from '@app/shared/ui/organisms/Admin/MatrixChannelForm';
import { Button } from '@app/shared/ui/atoms/Common';
import { Gender } from '@app/shared/types/common';
import { FormSchema, Story, StoryWithId } from '@app/shared/types/admin/pages/matrixChannelForm';

export default function AdminMatrixChannelFormPage() {
  const form = useForm<FormSchema>();
  const [gender, setGender] = useState<Gender>('f');
  const [stories, setStories] = useState<StoryWithId[]>([]);
  const { t } = useTranslation();

  const handleSubmit = (values: FormSchema) => {
    // TODO: handle submit
    alert(JSON.stringify(values));
  };

  const handleSubmitBtnClick = () => {
    form.handleSubmit(handleSubmit)();
  };

  const handleStoryCreate = (story: Story) => {
    setStories((prevState) => [...prevState, { id: uuidv7(), ...story }]);
  };

  const handleStoryUpdate = (id: string, story: Story) => {
    setStories((prevState) =>
      prevState.map((item) => (item.id === id ? { ...item, ...story } : item))
    );
  };

  const handleStoryRemove = (id: string) => {
    setStories((prevState) => prevState.filter((item) => item.id !== id));
  };

  return (
    <div className="flex flex-col gap-4">
      <TopBar />

      <Form form={form} onSubmit={handleSubmit} gender={gender} onGenderChange={setGender} />

      <StoriesSection
        stories={stories}
        onStoryCreate={handleStoryCreate}
        onStoryUpdate={handleStoryUpdate}
        onStoryRemove={handleStoryRemove}
      />

      <Button onClick={handleSubmitBtnClick}>{t('common.send')}</Button>
    </div>
  );
}
